<template>
	<div class="page">

		<scroll-to :links="scrollTo"></scroll-to>


		<div class="page-content-wrap">
			

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>


				<div class="row">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work">
						<sortableImages @exportImages="exportImages" :images="www.images"></sortableImages>
					</div>
				</div> 

				<div class="row">
					<h3 id="s2" class="title-steps">Мета дани</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.renderForms" @exportMeta="exportMeta" :formElements="formElements"></forms>
					</div>
				</div> 


				<div class="row">
					<h3 id="s3" class="title-steps">Производител</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.brand" :where="'shop/brand/search'" @exportList="exportBrands"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s3" class="title-steps">Категория</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.category" :where="'shop/category/search'" @exportList="exportCategories"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Доп. елементи</h3>
					<div class="col-lg-12 section-work">
						<soft-element :for="'product'" @exportElements="exportAdditionalElements" ></soft-element>
					</div>
				</div>

				<div class="row">
					<h3 id="s3" class="title-steps">Опции</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="15" :filters="www.options" :where="'soft/option/search'" @exportList="exportOption"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Значение за опции</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.stateFormptions" @exportMeta="exportFormOptions" :formElements="formOptions"></forms>
						<div v-else>
							<p>Избери опции</p>
						</div>
					</div>
				</div>

			<!-- 	<div class="row">
					<h3 id="collection" class="title-steps">Колекция</h3>

					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.collection" :where="'shop/collection/search'" @exportList="exportCollections"></form-list>
					</div>
				</div> -->
				

			</div>

			
		</div>
		
		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>
	
	import ModalCreateFolder from "../../app_modules/ModalCreateFolder";


	import ScrollTo from '../../../components/layouts/ScrollTo'
	import Errors from '../../../components/app_modules/Errors'
	import BottomMenu from '../../../components/app_modules/BottomMenu'
	
	import SortableImages from '../../../components/app_modules/SortableImages'
	import SortableCategory from '../../../components/app_modules/SortableCategory'
	// import SortableFilter from '../../../components/app_modules/SortableFilter'
	import OptionProduct from '../../../components/app_modules/Option'

	import SortableProducts from '../../../components/app_modules/SortableProducts.vue'
	import SoftElement from '../../../components/app_modules/SoftElement'

	import Forms from '../../../components/app_modules/Forms'
	import FormList from '../../../components/app_modules/FormList'
	import Editor from '../../../components/app_modules/Editor'
	//import SortableCategory from '../../../components/app_modules/SortableCategory'

	import axios from 'axios'

	export default {
		name: 'shop-product-create',

		data() {
			return {
				productPage: true,
				modalCreateFolder: false,
				renderForms:false,
				renderFormOtions:false,
				from: 'brands',
				componentKey: 0,
				stateFormptions: false,
				toMany: true,

				www: {
					link_send: this.$store.getters.getDomainName+'shop/product',
					method: 'post',
					redirect: 'shop-product',

					title: '',
					status: 'true',
					price: '',
					price_discount: '',
					product_id: 0,
					code: '',
					families: '',
					description: '',
					images: [],
					brand: [],
					category:[],
					options:[],

				},

				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'Title',
					placeholder: 'title',
					model: '',
					readonly:true,
				},
				
				{
					id: 1,
					type: 'input',
					name: 'link',
					placeholder: 'link',
					model: '',
					readonly:true
				},
				{
					id: 2,
					type: 'input',
					name: 'code',
					placeholder: 'code',
					model: '',
					readonly:true
				},
				{
					id: 3,
					type: 'input',
					name: 'poss',
					placeholder: 'Позиция',
					model: '',
					readonly:true
				},
				{
					id: 4,
					type: 'input',
					name: 'families',
					placeholder: 'Симейство',
					model: '',
					readonly:true
				},

				{
					id: 5,
					type: 'input',
					name: 'description',
					placeholder: 'description',
					model: '',
					readonly:true
				},
				
				{
					id: 6,
					type: 'status',
					name: 'status',
					model: true,
				},

				],

				formOptions: [

				],

				scrollTo: [
				{
					id: 1,
					name: 'Снимки',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Мета дани',
					href: '#s2',
				},
				
				{
					id: 3,
					name: 'Производител',
					href: '#s3',
				},
				
				
				
				]
			}
		},
		methods: {
			exportAdditionalElements(data) {

				this.www.additionalElements = data

			},
			// exportContent(data) {
			// 	this.www.description = data
			// },

			exportFormOptions(data) {
				console.log( data)
				this.generateData('dataOptions', data)
			},
			exportOption(data) {
				
				data = data.reverse()

				this.formOptions.push({ 

					id: data[0].id,
					ids: data[0].id,
					type: 'input',
					name: data[0].title,
					placeholder: 'цена за ' + data[0].title,
					model: data[0].value,
					readonly: true,
					selected: true,
				})
				this.stateFormptions = true

				// this.generateForm('formOptions', data)
			},

			exportBrands(data) {
				this.www.brand = data
			},
			exportCategories(data) {
				this.www.category = data
			},
			exportMeta(data) {

				this.www.title = data[0].model
				this.www.link = data[1].model
				this.www.code = data[2].model
				this.www.poss = data[3].model
				this.www.families = data[4].model
				this.www.description = data[5].model
				this.www.status = data[6].model

			},
			
			exportImages(data) {

				this.www.images = data
			},

			generateForm(nameObject, data) {

				if(nameObject == 'formOptions') {
					this.formOptions = []
				} 
				if(nameObject == 'formMaterials') {
					this.formMaterials = []
				}

				var formData = [];

				for (var i = data.length - 1; i >= 0; i--) {

					if(data[i].title != '') {

						if(!data[i].value) {
							data[i].value = '' 
						}
						if(data[i].price) {
							data[i].value = data[i].price
						}

						formData.push({ 

							id: data[i].id,
							ids: data[i].id,
							type: 'input',
							name: data[i].title,
							placeholder: 'цена за ' + data[i].title,
							model: data[i].value,
							readonly: true,
							selected: true,
						})
					}
				}

				if(nameObject == 'formOptions') {
					this.formOptions = formData
					this.stateFormptions = true

				} 
				if(nameObject == 'formMaterials') {
					this.formMaterials = formData
					this.stateformMaterials = true

				}

			},

			generateData(nameObject, form) {


				
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = []
				}
				if(nameObject == 'dataOptions') {
					// this.dataOptions = []
				}

				var data = [];

				for (var i = form.length - 1; i >= 0; i--) {



					data.push({ 

						id: form[i].id,
						ids: form[i].ids,
						title: form[i].name,
						value: form[i].model,
					})
				}

				if(nameObject == 'dataOptions') {
					this.www.dataOptions = data
					
				}
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = data

					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
				}


			},
			

			
		},
		created() {
			eventBus.$on('closeModalCreateFolder', data => {
				this.modalCreateFolder = data
			})


			if(this.$route.name == 'shop-product-edit') {
				axios.get(this.$store.getters.getDomainName+'shop/product/'+this.$route.params.id+'/edit')

				.then(response => {


					this.www.product_id = response.data['id']
					this.www.title = response.data['title']
					this.www.link = response.data['link']
					this.www.category = response.data['category']
					this.www.code = response.data['code']
					this.www.poss = response.data['poss']
					this.www.families = response.data['families']
					this.www.desciption = response.data['desciption']
					this.www.status = response.data['status']

					this.www.brand = response.data['brand']
					
					this.generateForm('formOptions', response.data['options'])
					this.www.dataOptions = response.data['options']

					this.www.options = response.data['options']


					// send active category

					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						if(images[i] != '') {
							this.www.images.push({ 
								icon: images[i],
								id: i,
							})
						}
						
					}

					console.log()


					this.formElements[0].model = response.data['title']
					this.formElements[1].model = response.data['link']
					this.formElements[2].model = response.data['code']
					this.formElements[3].model = response.data['poss']

					this.formElements[4].model = response.data['families']
					this.formElements[5].model = response.data['description']



					response.data['status'] == 0 ? this.formElements[6].model = false : this.formElements[6].model = true


					if(response.data['status'] == 0) {
						this.formElements[6].model = false
					} else {
						this.formElements[6].model = true
					}




					this.www.link_send = this.$store.getters.getDomainName+'shop/product/'+this.$route.params.id
					this.www.method = 'patch'


					eventBus.$emit('sendLinkAndMethod', this.www)
					//this.www = response.data

					this.renderForms = true
					return


				})
				.catch(error => {
					// if(error.response.status == 404) {
					// 	this.$router.push({ name: '404' })
					// }
				})

				
			} else {
				this.renderForms = true
			}
		},
		beforeDestroy() {
			eventBus.$off('closeModalCreateFolder')
		},
		components: {
			ModalCreateFolder,
			Forms,
			ScrollTo,
			Editor,
			//SortableCategory,
			Errors,
			BottomMenu,
			SortableImages,
			SortableCategory,
			SortableProducts,
			// SortableFilter,
			FormList,
			OptionProduct,
			SoftElement,
		},

	}
</script>

<style scoped>
@import url(../../../assets/css/page-data.css);


</style>


// WEBPACK FOOTER //
// src/components/shop/product/data.vue